import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import CompanyGroupSelection from 'modules/surveys/components/CompanyGroupSelection'
import LocationGroupSelection from 'modules/surveys/components/LocationGroupSelection'
import TeamGroupSelection from 'modules/surveys/components/TeamGroupSelection'

interface Props {
  strategy: Field
  groupField: Field
  groupableIdField: Field
  disabled?: boolean
}

function DynamicGroupSelection({
  disabled = false,
  strategy,
  groupField,
  groupableIdField,
}: Props) {
  const groupOptions = React.useRef([
    {
      value: AccessGroup.CompanyGroup,
      label: i18n.t('surveys.new.form.labels.company.title'),
    },
    {
      value: AccessGroup.GroupableTypes.team,
      label: i18n.t('surveys.new.form.labels.team'),
    },
    {
      value: AccessGroup.GroupableTypes.location,
      label: i18n.t('surveys.new.form.labels.office'),
    },
  ]).current

  return (
    <Box gap="s16">
      <Select
        none={i18n.t('common.none')}
        readonly={disabled}
        field={groupField}
        options={groupOptions}
      />
      {groupField.value === AccessGroup.CompanyGroup && (
        <CompanyGroupSelection readonly={disabled} field={strategy} />
      )}
      {groupField.value === AccessGroup.GroupableTypes.team && (
        <TeamGroupSelection readonly={disabled} field={groupableIdField} />
      )}
      {groupField.value === AccessGroup.GroupableTypes.location && (
        <LocationGroupSelection readonly={disabled} field={groupableIdField} />
      )}
    </Box>
  )
}

export default observer(DynamicGroupSelection)
